<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        Summary
    </div>
    <div class="card-body" style="overflow: auto; height: 450px;">
        <div class="card-body p-1" style="overflow: auto;">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Present</th>
                        <th scope="col">Week Off</th>
                        <th scope="col">Comp Off</th>
                        <th scope="col">Paid Leave</th>
                        <th scope="col">Paid Holiday</th>
                        <th scope="col">Mis Punch</th>
                        <th scope="col">Absent</th>
                        <th scope="col">Half Day</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let TableData of TableDatas; let i = index">
                        <th scope="row" style="width: 5px;">{{i+1}}</th>
                        <td>{{TableData['PRESENT']}}</td>
                        <td>{{TableData['WEEK OFF']}}</td>
                        <td>{{TableData['CompOff']}}</td>
                        <td>{{TableData['PAID LEAVE']}}</td>
                        <td>{{TableData['PAID HOLIDAY']}}</td>
                        <td>{{TableData['MIS PUNCH']}}</td>
                        <td>{{TableData['ABSENT']}}</td>
                        <td>{{TableData['HALF DAY']}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">
                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-outline-primary btn-sm" [disabled]="isDisabled" (click)="Cancel()"
                    autofocus="true" #cancelButton id="cancelButton">
                    <i class="bi bi-x-lg" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>